import loadable from '@loadable/component'

export default [
  {
    path: '/roomBanner/RoomWaterRebate', // 房间流水返利 房间banner h5页面
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RoomBanner-RoomWaterRebate" */ '~/pages/RoomBanner/RoomWaterRebate'
        )
    ),
  },
  {
    path: '/roomBanner/SmallRocket', // 房间小火箭 房间banner h5页面
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-RoomBanner-SmallRocket" */ '~/pages/RoomBanner/SmallRocket'
        )
    ),
  },
]
